import { API_TYPE } from 'utils/client'

export const HOST_NAME =
    import.meta.env.VITE_ENV === 'development'
        ? import.meta.env.VITE_API_HOSTNAME_DEV
        : import.meta.env.VITE_API_HOSTNAME

export const host = HOST_NAME + '/v1/'

const API_CONFIG = {
    USER_CREATE: {
        url: `${host}user`,
        type: 'post' as API_TYPE,
        headers: null,
        isProtected: false,
        isJson: true,
        urlParams: null,
        body: null,
        message: {
            success: 'Hi! You have been successfully registered',
            error: {
                400: 'Please enter a valid Username/Password, and Name',
                409: 'Please login with your username/password as this email is already registered with us',
                502: 'Please try again after some time. Engineers are at work!',
            },
        },
    },
    USER_UPDATE: {
        url: `${host}user`,
        type: 'put' as API_TYPE,
        isProtected: true,
        isJson: true,
        urlParams: null,
        body: null,
        message: {
            success: 'Hi! User has been updated successfully',
            error: {
                401: 'Please retry the forgot password again, your time to reset password has expired',
                403: 'An event has been logged. You are trying to use an invalid verification code to reset the password',
                502: 'Please try again after some time. Engineers are at work!',
            },
        },
    },
    USER_DETAILS: {
        url: `${host}user`,
        type: 'get' as API_TYPE,
        hasLoader: false,
        headers: null,
        isProtected: true,
        isJson: true,
        urlParams: null,
        body: null,
        message: {
            success: '',
            error: {
                500: 'Please refresh the page. We have encountered an error',
                502: 'Please try again after some time. Engineers are at work!',
            },
        },
    },
    USER_LOGIN: {
        url: `${host}user/login`,
        type: 'post' as API_TYPE,
        headers: null,
        isProtected: false,
        isJson: false,
        urlParams: null,
        body: null,
        message: {
            success: 'Hi! Welcome to WonderlyAR',
            error: {
                400: 'Please enter your valid Username/Password',
                401: 'Please enter your username and password',
                403: 'Please wait for sometime. You have been blocked due to exceeded number of failed attempts',
                502: 'Please try again after some time. Engineers are at work!',
            },
        },
    },
    USER_SEND_VERIFICATION_CODE: {
        url: `${host}user/forget-password`,
        type: 'post' as API_TYPE,
        headers: null,
        isProtected: false,
        isJson: true,
        urlParams: null,
        body: null,
        message: {
            success: 'Hi! Password reset email has been sent to your email address',
            error: {
                400: 'You are not a registered user. Please register yourself',
                502: 'Please try again after some time. Engineers are at work!',
            },
        },
    },
    USER_VERIFY: {
        url: `${host}user/change-password`,
        type: 'post' as API_TYPE,
        headers: null,
        isProtected: false,
        isJson: true,
        urlParams: null,
        body: null,
        message: {
            success: 'Your password has been changed successfully!',
            error: {
                400: 'You have entered an invalid verification code',
                401: 'Please retry the forgot password again, your verification link has expired',
                502: 'Please try again after some time. Engineers are at work!',
            },
        },
    },
    USER_ONBOARDING: {
        url: `${host}user/onboarding`,
        type: 'post' as API_TYPE,
        isProtected: true,
        noBodyChange: true,
        isJson: true,
        message: {
            success: 'Thanks for telling us about yourself',
            error: {
                400: 'Please login again, your token has expired',
                502: 'Please try again after some time. Engineers are at work!',
            },
        },
    },
    USAGE_QUICK_STATS: {
        url: `${host}usage`,
        type: 'get' as API_TYPE,
        headers: null,
        isProtected: true,
        isJson: true,
        urlParams: null,
        body: null,
        message: {
            success: '',
            error: {
                500: 'Please try again after some time. Engineers are at work!',
                502: 'Please try again after some time. Engineers are at work!',
            },
        },
    },
    REFRESH_API_KEY: {
        url: `${host}user/new-api-key`,
        type: 'get' as API_TYPE,
        headers: null,
        isProtected: true,
        isJson: true,
        urlParams: null,
        body: null,
        message: {
            success: 'A new API key has been created for you',
            error: {
                500: 'Please try again after some time. Engineers are at work!',
            },
        },
    },
    GET_MODEL_URL: {
        url: `${host}product/get-model`, // get-model/fileName
        type: 'get' as API_TYPE,
        isProtected: true,
        isJson: true,
        message: {
            success: '',
            error: {
                400: 'Please login again, your token has expired',
                401: 'You do not have permissions to get the model',
                500: 'Please try again after some time. Engineers are at work!',
                502: 'Please try again after some time. Engineers are at work!',
            },
        },
    },
    SAVE_NEW_TEXTURE: {
        url: `${host}texture`,
        type: 'post' as API_TYPE,
        isProtected: true,
        noBodyChange: true,
        isJson: true,
        message: {
            success: 'Texture saved successfully',
            error: {
                400: 'Please login again, your token has expired',
                401: 'You do not have permissions to upload the texture',
                500: 'Please try again after some time. Engineers are at work!',
                502: 'Please try again after some time. Engineers are at work!',
            },
        },
    },
    TEXTURE_DELETE: {
        url: `${host}texture/{textureId}`,
        type: 'delete' as API_TYPE,
        isProtected: true,
        noBodyChange: true,
        isJson: false,
        message: {
            success: 'Texture deleted successfully',
            error: {
                400: 'Please login again, your token has expired',
                401: 'You do not have permissions to delete the texture',
                500: 'Please try again after some time. Engineers are at work!',
                502: 'Please try again after some time. Engineers are at work!',
            },
        },
    },
    PRODUCTS_LIST: {
        url: `${host}product`,
        type: 'get' as API_TYPE,
        isProtected: true,
        isJson: true,
        body: null,
        message: {
            success: '',
            error: {
                500: 'Please try again after some time. Engineers are at work!',
                502: 'Please try again after some time. Engineers are at work!',
            },
        },
    },
    PRODUCT_CREATE: {
        url: `${host}product`,
        type: 'post' as API_TYPE,
        isProtected: true,
        noBodyChange: true,
        isJson: true,
        message: {
            success: 'Product has been created successfully',
            error: {
                400: 'Sorry, You have reached the limit to create a product. Please upgrade your plan to create more',
                500: 'Please try again after some time. Engineers are at work!',
                502: 'Please try again after some time. Engineers are at work!',
            },
        },
    },
    BULK_MODEL_UPLOAD: {
        url: `${host}product/bulk/model`,
        type: 'post' as API_TYPE,
        isProtected: true,
        noBodyChange: false,
        isJson: true,
        message: {
            success: 'All models have been uploaded successfully',
            error: {
                500: 'Please try again after some time. Engineers are at work!',
            },
        },
    },
    PRODUCT_DETAILS: {
        url: `${host}product`,
        type: 'get' as API_TYPE,
        isProtected: true,
        isJson: true,
        message: {
            success: '',
            error: {
                400: 'Please login again, your token has expired',
                401: 'You do not have permissions to edit this product',
                500: 'Please try again after some time. Engineers are at work!',
                502: 'Please try again after some time. Engineers are at work!',
            },
        },
    },
    PRODUCT_UPDATE: {
        url: `${host}product/{productId}`,
        type: 'put' as API_TYPE,
        isProtected: true,
        noBodyChange: true,
        isJson: true,
        message: {
            success: 'Product saved successfully',
            error: {
                400: 'Please login again, your token has expired',
                401: 'You do not have permissions to edit this product',
                500: 'Please try again after some time. Engineers are at work!',
                502: 'Please try again after some time. Engineers are at work!',
            },
        },
    },
    PRODUCT_DELETE: {
        url: `${host}product/{productId}`,
        type: 'delete' as API_TYPE,
        isProtected: true,
        isJson: false,
        message: {
            success: 'Product deleted successfully',
            error: {
                400: 'Please login again, your token has expired',
                401: 'You do not have permissions to delete this product',
                500: 'Please try again after some time. Engineers are at work!',
                502: 'Please try again after some time. Engineers are at work!',
            },
        },
    },
    FILE_UPLOAD: {
        url: `${host}file/start-file-upload`,
        type: 'get' as API_TYPE,
        isProtected: true,
        isJson: false,
        message: {
            success: 'File uploaded successfully',
            error: {
                400: 'Please login again, your token has expired',
                401: 'You do not have permissions to upload the file',
                500: 'Please try again after some time. Engineers are at work!',
                502: 'Please try again after some time. Engineers are at work!',
            },
        },
    },
    UPGRADE_MEMBERSHIP: {
        url: `${host}membership/order`,
        type: 'post' as API_TYPE,
        isProtected: true,
        isJson: true,
        message: {
            success: 'Order verified successfully, upgrading your membership',
            error: {
                400: 'Please login again, your token has expired',
                401: 'You do not have permissions to create this order',
                500: 'Please try again after some time. Engineers are at work!',
                502: 'Please try again after some time. Engineers are at work!',
            },
        },
    },
    VARIANT_CREATE: {
        url: `${host}product/{productId}/variant`,
        type: 'post' as API_TYPE,
        isProtected: true,
        noBodyChange: true,
        isJson: true,
        message: {
            success: 'Variant created successfully',
            error: {
                400: 'Sorry, You have reached the limit to create a variant. Please upgrade your plan to create more',
                401: 'You do not have permissions to create a variant',
                402: 'Your subscription has expired, Please upgrade your plan',
                403: 'You do not have permissions to create a variant',
                500: 'Please try again after some time. Engineers are at work!',
            },
        },
    },
    VARIANT_UPDATE: {
        url: `${host}product/{productId}/variant/{variantId}`,
        type: 'put' as API_TYPE,
        isProtected: true,
        noBodyChange: true,
        isJson: true,
        message: {
            success: 'Variant updated successfully',
            error: {
                400: 'Failed to update this variant, Please try again later',
                401: 'You do not have permissions to edit a variant',
                402: 'Your subscription has expired, Please upgrade your plan',
                403: 'You do not have permissions to edit this variant',
                500: 'Please try again after some time. Engineers are at work!',
            },
        },
    },
    VARIANT_DETAILS: {
        url: `${host}product/{productId}/variant/{variantId}`,
        type: 'get' as API_TYPE,
        isProtected: true,
        isJson: true,
        message: {
            success: '',
            error: {
                401: 'You do not have permissions to get a variant',
                402: 'Your subscription has expired, Please upgrade your plan',
                403: 'You do not have permissions to get a variant',
                404: 'Failed to get this variant, Please try again later',
                500: 'Please try again after some time. Engineers are at work!',
            },
        },
    },
    VARIANTS_LIST: {
        url: `${host}product/{productId}/variant`,
        type: 'get' as API_TYPE,
        isProtected: true,
        isJson: true,
        body: null,
        message: {
            success: '',
            error: {
                401: 'You do not have permissions to get variants',
                402: 'Your subscription has expired, Please upgrade your plan',
                403: 'You do not have permissions to get a variant',
                500: 'Please try again after some time. Engineers are at work!',
            },
        },
    },
    DELETE_VARIANT: {
        url: `${host}product/{productId}/variant/{variantId}`,
        type: 'delete' as API_TYPE,
        isProtected: true,
        isJson: false,
        body: null,
        message: {
            success: '',
            error: {
                401: 'You do not have permission to delete variant',
                402: 'Your subscription has expired, Please upgrade your plan',
                403: 'You do not have permissions to delete a variant',
                500: 'Please try again after some time. Engineers are at work!',
            },
        },
    },
    DEMO_PRODUCT_DETAILS: {
        url: `${host}product/common/demo-product`,
        type: 'get' as API_TYPE,
        isProtected: true,
        isJson: true,
        message: {
            success: '',
            error: {
                400: 'Failed to get this product, Please try again later',
                401: 'You do not have permissions to get this product',
                402: 'Your subscription has expired, Please upgrade your plan',
                403: 'You do not have permissions to get this product',
                500: 'Please try again after some time. Engineers are at work!',
            },
        },
    },
    THEME_CREATE: {
        url: `${host}user/theme`,
        type: 'post' as API_TYPE,
        isProtected: true,
        noBodyChange: true,
        isJson: true,
        message: {
            success: 'Custom theme has been created successfully',
            error: {
                401: 'You do not have permissions to create a theme',
                402: 'Your subscription has expired, Please upgrade your plan',
                403: 'You do not have permissions to create a theme',
                500: 'Please try again after some time. Engineers are at work!',
            },
        },
    },
    THEME_DETAILS: {
        url: `${host}user/theme`,
        type: 'get' as API_TYPE,
        isProtected: true,
        isJson: true,
        message: {
            success: '',
            error: {
                401: 'You do not have permissions to get this theme',
                402: 'Your subscription has expired, Please upgrade your plan',
                403: 'You do not have permissions to get this theme',
                500: 'Please try again after some time. Engineers are at work!',
            },
        },
    },
    THEME_UPDATE: {
        url: `${host}user/theme`,
        type: 'put' as API_TYPE,
        isProtected: true,
        noBodyChange: false,
        isJson: true,
        message: {
            success: 'Theme saved successfully',
            error: {
                401: 'You do not have permissions to update this theme',
                402: 'Your subscription has expired, Please upgrade your plan',
                403: 'You do not have permissions to update this theme',
                500: 'Please try again after some time. Engineers are at work!',
            },
        },
    },
    THEME_DELETE: {
        url: `${host}user/theme`,
        type: 'delete' as API_TYPE,
        isProtected: true,
        isJson: false,
        message: {
            success: 'Theme deleted successfully',
            error: {
                401: 'You do not have permissions to delete this theme',
                402: 'Your subscription has expired, Please upgrade your plan',
                403: 'You do not have permissions to delete this theme',
                500: 'Please try again after some time. Engineers are at work!',
            },
        },
    },
}

export default API_CONFIG
